<template>
  <span
    :class="['-transcribe-gap', '-gap', guid, { '-irrelevant': !isRelevant }]"
    v-tooltip="{
      title: tooltipText,
      // container: '.' + guid,
      placement: 'top',
      delay: 50,
      wrapperClass: 'dark',
    }"
    @click="onClick"
    ><i class="wticon wticon-plus" />+</span
  >
</template>

<script>
export default {
  name: 'wt-transcribe-gap',
  props: {
    tokenData: {
      type: Object,
      required: true,
    },
    tokenIndex: {
      type: Number,
      required: true,
    },
    isRelevant: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      guid: app.guid(),
      tooltipText: app.culture.get('transcribe.insertText'),
    };
  },
  mounted() {
    this.$el._tokenData = this.tokenData;
    this.$el._tokenIndex = this.tokenIndex;
  },
  beforeDestroy() {},
  methods: {
    onClick() {
      this.$emit('click', {
        tokenData: this.tokenData,
        tokenIndex: this.tokenIndex,
      });
    },
  },
};
</script>

<style lang="scss">
.-transcribe-gap {
  position: relative;
  cursor: pointer;
  color: rgba(255, 255, 255, 0);
  // padding: 0 .25ch;
  display: inline-block;
  text-align: center;
  box-sizing: border-box;

  &.-highlight {
    background: none !important;
    &:after {
      border-radius: 50%;
      content: ' ';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 12px;
      height: 12px;
      pointer-events: none;
      background-color: rgba(6, 169, 244, 0.2);
      transform: translate(-50%, -50%);
    }
  }

  .wticon {
    pointer-events: none;
    user-select: none;
    position: absolute;
    z-index: 1;
    color: white;
    transform: translate(-50%, -50%) scale(0);
    left: 50%;
    top: 50%;
    font-size: 10px;
    transition: all 0.1s ease;
  }

  &:before {
    content: ' ';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 6px;
    height: 6px;
    background-color: #06a9f4;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.1s ease;
    z-index: -1;
    pointer-events: none;
  }

  &:hover {
    // color: rgba(255,255,255, 1);

    &:before {
      width: 16px;
      height: 16px;
    }
    .wticon {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>
